(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rb-review-submission"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rb-review-form')) {
    class RBReviewForm extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.dialog = this.querySelector('dialog');
        this.opener = this.querySelector('[data-review-form-open]') || this.opener;
        this.formHost = this.querySelector('[data-review-form-host]');
        this.fallback = this.querySelector('[data-review-fallback]');
        this.formLoading = this.querySelector('[data-review-form-loading]');
        this.formError = this.querySelector('[data-review-form-error]');
        const on = (element, event, handler) => element.addEventListener(event, handler, { signal: this.controller.signal });
        on(this.opener, 'click', () => this.open());
        const fallbackButton = this.querySelector('[data-review-use-fallback]');
        if (fallbackButton) on(fallbackButton, 'click', () => { this.formFailed(); this.fallback.querySelector('input:not([type=hidden])')?.focus(); });
        const retry = this.querySelector('[data-review-form-retry]');
        if (retry) on(retry, 'click', () => {
          this.mountForm(true);
          this.watchForm();
        });
        const desktop = matchMedia('(min-width: 990px)');
        const placeOpener = () => {
          const overview = this.closest('.rbnr--feed')?.querySelector('.rbnr-overview');
          if (desktop.matches && overview) overview.append(this.opener);
          else this.insertBefore(this.opener, this.dialog);
        };
        on(desktop, 'change', placeOpener);
        placeOpener();
        if (this.fallback?.querySelector('[data-intake-result]') && location.hash === '#' + this.fallback.querySelector('form').id) queueMicrotask(() => this.open());
        this.querySelectorAll('[data-review-form-close]').forEach(button => on(button, 'click', () => this.dialog.close()));
        on(this.dialog, 'close', () => this.restore());
        this.styleForm = () => {
          if (this.fallback && !this.fallback.hidden) return false;
          const frameDocument = this.formHost?.querySelector('iframe')?.contentDocument;
          const styleDocument = frameDocument || document;
          const embed = frameDocument?.querySelector('shopify-forms-embed') || this.querySelector('shopify-forms-embed');
          const root = embed?.shadowRoot;
          if (!root?.querySelector('form, [data-testid="app-router"]')) return false;
          if (frameDocument) {
            const inheritedStyle = getComputedStyle(this);
            for (const property of ['--rb-primary-cta-radius', '--rb-primary-cta-height', '--rb-radius-control', '--rb-plum', '--rb-white', '--rb-ink-muted', '--rb-border', '--rb-rose']) {
              frameDocument.documentElement.style.setProperty(property, inheritedStyle.getPropertyValue(property));
            }
          }
          const main = this.closest('main') || document.body;
          const outsideReviews = element => !element.closest('.rbnr-section, .rbnr, rb-review-form');
          const bodyReference = main.querySelector('.rb-showcase-text p') || [...main.querySelectorAll('.rte p')].find(outsideReviews) || document.body;
          const headingReference = main.querySelector('.rb-showcase-title, .rb-video-heading') || [...main.querySelectorAll('h2')].find(outsideReviews) || this.querySelector('h2');
          const bodyStyle = getComputedStyle(bodyReference);
          const headingStyle = getComputedStyle(headingReference);
          const themeFont = style => `${style.fontStyle} ${style.fontWeight} ${style.fontSize}/${style.lineHeight} ${style.fontFamily}`;
          for (const [kind, reference] of [['body', bodyStyle], ['heading', headingStyle]]) {
            const values = { font: themeFont(reference), size: reference.fontSize, spacing: reference.letterSpacing, color: reference.color };
            for (const [property, value] of Object.entries(values)) {
              const key = `--rb-review-${kind}-${property}`;
              if (styleDocument.documentElement.style.getPropertyValue(key) !== value) styleDocument.documentElement.style.setProperty(key, value);
            }
          }
          if (this.formHost) {
            this.formLoading.hidden = true;
            this.formError.hidden = true;
            this.formHost.hidden = false;
            this.formHost.setAttribute('aria-busy', 'false');
          }
          if (root.querySelector('#rb-review-form-style')) return true;
          const style = document.createElement('style');
          style.id = 'rb-review-form-style';
          style.textContent = `
            :host { --inline-container-max-width: 100% !important; --button-border-radius: var(--rb-primary-cta-radius) !important; --form-field-border-radius: var(--rb-radius-control) !important; --forms-base-font-size: var(--rb-review-body-size) !important; --forms-heading-font-size: var(--rb-review-heading-size) !important; --forms-body-font: var(--rb-review-body-font) !important; --forms-heading-font: var(--rb-review-heading-font) !important; --button-background-color: var(--rb-plum) !important; --button-text-color: var(--rb-white) !important; --body-text-color: var(--rb-review-body-color) !important; --heading-text-color: var(--rb-review-heading-color) !important; --form-text-color: var(--rb-review-body-color) !important; --form-background-color: var(--rb-white) !important; --form-placeholder-color: var(--rb-ink-muted) !important; --forms-accent-color: var(--rb-plum) !important; --link-text-color: var(--rb-plum) !important; --form-field-border: 0 0 0 1px var(--rb-border) !important; --form-field-border-focused: 0 0 0 2px var(--rb-plum) !important; }
            div:has(> input[type="text"]) , div:has(> textarea[name="custom#review"]) { display: flex !important; flex-direction: column !important; gap: 6px !important; }
            div:has(> textarea[name="custom#review"])::before { content: none !important; display: none !important; }
            input[type="text"] ~ label, textarea[name="custom#review"] ~ label { all: unset !important; display: block !important; position: relative !important; inset: auto !important; z-index: 1 !important; order: -1 !important; transform: none !important; margin: 0 !important; padding: 0 !important; font: var(--rb-review-body-font) !important; letter-spacing: var(--rb-review-body-spacing) !important; color: var(--rb-review-body-color) !important; pointer-events: auto !important; }
            input[type="text"], textarea[name="custom#review"] { box-sizing: border-box !important; padding: 12px 14px !important; min-height: 48px !important; font: var(--rb-review-body-font) !important; letter-spacing: var(--rb-review-body-spacing) !important; color: var(--rb-review-body-color) !important; }
            h2 { font: var(--rb-review-heading-font) !important; letter-spacing: var(--rb-review-heading-spacing) !important; color: var(--rb-review-heading-color) !important; }
            p, legend { font: var(--rb-review-body-font) !important; letter-spacing: var(--rb-review-body-spacing) !important; color: var(--rb-review-body-color) !important; }
            button[type="submit"] { box-sizing: border-box !important; min-height: var(--rb-primary-cta-height) !important; font-weight: 700 !important; transition: transform .2s, opacity .2s; }
            button[type="submit"]:hover:not(:disabled) { transform: translateY(-1px); opacity: .94; filter: none; }
            button[type="submit"]:focus-visible { outline: 2px solid var(--rb-plum); outline-offset: 4px; }
            fieldset[name="custom#rating"] > div { display: flex; gap: 8px; }
            fieldset[name="custom#rating"] label { position: relative; display: grid; grid-template-columns: 1fr; gap: 0; place-items: center; width: 46px; min-height: 46px; cursor: pointer; color: var(--rb-ink-muted); }
            fieldset[name="custom#rating"] input { position: absolute; inset: 0; width: 100%; height: 100%; opacity: 0; cursor: pointer; }
            fieldset[name="custom#rating"] span { font-size: 0; color: inherit; }
            fieldset[name="custom#rating"] span::after { content: '★'; font-size: 36px; line-height: 1; }
            fieldset[name="custom#rating"] label:has(input:checked), fieldset[name="custom#rating"] label:has(~ label input:checked) { color: var(--rb-rose); }
            fieldset[name="custom#rating"] label:has(input:focus-visible) { outline: 2px solid var(--rb-plum); outline-offset: 2px; border-radius: 6px; }
          `;
          root.append(style);
          return true;
        };
        on(window, 'resize', () => { if (this.dialog.open) this.styleForm(); });
        this.fontWatch = new MutationObserver(() => { if (this.dialog.open) this.styleForm(); });
        on(this.dialog, 'click', event => {
          if (event.target !== this.dialog) return;
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
        });
        on(this.dialog, 'keydown', event => {
          if (event.key !== 'Tab') return;
          const fields = [...this.dialog.querySelectorAll('button:not([disabled]), input:not([type="hidden"]):not([disabled]), textarea, select, a[href]')].filter(field => field.getClientRects().length);
          const first = fields[0], last = fields[fields.length - 1];
          if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
          else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
        });
      }
      mountForm(retry = false) {
        if (!this.formHost) return;
        if (retry) this.formHost.replaceChildren();
        this.formLoading.hidden = false;
        this.formError.hidden = true;
        this.formHost.hidden = false;
        this.formHost.setAttribute('aria-busy', 'true');
        if (this.formHost.querySelector('iframe')) return;
        const frame = document.createElement('iframe');
        frame.className = 'rbnr-write-frame';
        frame.title = this.querySelector('h2').textContent.trim();
        frame.src = this.formHost.dataset.reviewFormUrl;
        frame.addEventListener('error', () => this.formFailed(), { signal: this.controller.signal });
        this.formHost.append(frame);
      }
      watchForm() {
        clearInterval(this.formStyleTimer);
        if (this.fallback && !this.fallback.hidden) return;
        if (this.styleForm()) return;
        let attempts = 0;
        this.formStyleTimer = setInterval(() => {
          if (!this.dialog.open || this.styleForm()) {
            clearInterval(this.formStyleTimer);
          } else if (++attempts >= (this.fallback ? 10 : 150)) {
            this.formFailed(true);
          }
        }, 200);
      }
      formFailed(allowLateReady = false) {
        clearInterval(this.formStyleTimer);
        if (!this.formHost) return;
        if (this.fallback) {
          this.formHost.hidden = true;
          this.formHost.setAttribute('aria-busy', 'false');
          this.formLoading.hidden = this.formError.hidden = true;
          this.fallback.hidden = false;
          return;
        }
        this.formLoading.hidden = true;
        this.formHost.hidden = !allowLateReady;
        this.formHost.setAttribute('aria-busy', String(allowLateReady));
        this.formError.hidden = false;
        if (allowLateReady && this.dialog.open) {
          this.formStyleTimer = setInterval(() => {
            if (!this.dialog.open || this.styleForm()) clearInterval(this.formStyleTimer);
          }, 1000);
        }
      }
      open() {
        if (this.dialog.open) return;
        this.scroll = window.scrollY;
        this.saved = ['position', 'top', 'left', 'right', 'width', 'overflow'].map(key => [key, document.body.style.getPropertyValue(key), document.body.style.getPropertyPriority(key)]);
        this.dialog.showModal();
        if (this.fallback && (!this.fallback.hidden || this.fallback.querySelector('[data-intake-result]'))) this.formFailed();
        else { this.mountForm(); this.watchForm(); }
        this.fontWatch.observe(document.documentElement, { attributes: true, attributeFilter: ['style', 'class'] });
        this.fontWatch.observe(document.head, { childList: true, subtree: true, characterData: true });
        Object.assign(document.body.style, { position: 'fixed', top: `${-this.scroll}px`, left: '0', right: '0', width: '100%', overflow: 'hidden' });
        this.dialog.querySelector('[data-review-form-close]').focus({ preventScroll: true });
      }
      restore() {
        clearInterval(this.formStyleTimer);
        this.fontWatch?.disconnect();
        if (!this.saved) return;
        for (const [key, value, priority] of this.saved) {
          if (value) document.body.style.setProperty(key, value, priority);
          else document.body.style.removeProperty(key);
        }
        this.saved = null;
        window.scrollTo({ top: this.scroll, behavior: 'instant' });
        if (this.opener.isConnected) this.opener.focus({ preventScroll: true });
      }
      disconnectedCallback() { if (this.opener && this.dialog) this.insertBefore(this.opener, this.dialog); clearInterval(this.formStyleTimer); this.fontWatch?.disconnect(); this.controller?.abort(); if (this.dialog?.open) this.dialog.close(); this.restore(); }
    }
    customElements.define('rb-review-form', RBReviewForm);
  }
  } catch(e) { console.error(e); }
})();

})();
